export const RADIUS_ICONS = [
    'radius_account',
    'radius_chart',
    'radius_flow',
    'radius_cake',
    'radius_home',
    'radius_business_trip',
    'radius_vacation',
    'radius_hospital',
    'radius_pregnant',
    'radius_room',
    'radius_circle',
    'radius_list',
    'radius_list_check',
    'radius_kanban',
    'radius_shrink',
    'radius_planing',
    'radius_hierarchy',
    'radius_module',
    'radius_settings',
    'radius_tune',
    'radius_mail',
    'radius_archive',
    'radius_skype',
    'radius_info',
    'radius_archive',
    'radius_star-border',
    'radius_star-filled',
    'radius_star-blue-filled',
    'radius_filters',
    'radius_alarm',
    'radius_bookmark-remove',
    'radius_bookmark_border',
    'radius_expand',
    'radius_people',
    'radius_delete_photo',
    'radius_gantt',
    'radius_clear',
    'radius_clipboard',
    'radius_main_gmail',
    'radius_event-busy',
    'radius_link',
    'radius_recover',
    'radius_finance',
    'radius_task',
    'radius_calendar',
    'radius_loader',
    'radius_delete',
    'radius_book-open',
    'radius_lock-open',
    'radius_add_to_drive',
    'radius_google_spreadsheet',
    'radius_google_presentation',
    'radius_google_doc',
    'radius_edit',
    'radius_task-control',
    'radius_phonebook',
    'radius_chat',
    'radius_chat_bold',
    'radius_two-people',
    'radius_one_chat',
    'radius_question',
    'radius_bell',
    'radius_bell_off',
    'radius_workgroup',
    'radius_arrow_up',
    'radius_done_green',
    'radius_rating',
    'radius_right',
    'radius_plus',
    'radius_delete_fill',
    'radius_done',
    'radius_delete_outline',
    'radius_folder',
    'radius_company',
    'radius_select_arrow',
    'radius_telegram_color',
    'radius_add',
    'radius_import',
    'format_list_bulleted',
    'radius_question_small',
    'radius_bug',
    'radius_blocked',
    'radius_importance1',
    'radius_importance2',
    'radius_importance3',
    'radius_quiz',
    'radius_telegram',
    'radius_pay_card',
    'radius_pay_qr',
    'radius_pay_invoice',
    'radius_bug_red',
    'radius_deal',
    'radius_exchange',
    'radius_circles',
    'radius_mask',
    'radius_matrix',
    'radius_list2',
    'radius_eclipse',
    'radius_position',
    'radius_beta',
    'radius_main',
    'radius_phone_connect',
    'radius_phone',
    'radius_email',
    'radius_mobile',
    'radius_blue_ok',
    'radius_grey_no',
    'radius_dots_1',
    'radius_dots_2',
    'radius_statistics',
    'radius_statistics_with_bg',
    'radius_clock',
    'radius_history',
    'radius_close_fullscreen',
    'radius_sort',
    'radius_download',
    'radius_select',
    'radius_visibility',
    'radius_save',
    'radius_bug_yellow',
    'radius_strategic_grey',
    'radius_strategic_yellow',
    'radius_strategic_red',
    'radius_copy',
    'radius_create_subtask',
    'radius_turn',
    'radius_book',
    'radius_btn-task',
    'radius_btn-meet',
    'radius_arrow_left',
    'radius_book-small',
    'radius_calendar_toggle',
    'radius_list-burg',
    'radius_sort_time_low',
    'radius_sort_time_top',
    'radius_sort_prior_top',
    'radius_sort_prior_low',
    'radius_hash',
    'radius_arrow_downward',
    'radius_arrow_upward',
    'radius_lock',
    'radius_sort_status_top',
    'radius_sort_status_low',
    'radius_editor_button',
    'radius_checklist',
    'radius_description',
    'radius_dod',
    'radius_actual_result',
    'radius_date_start',
    'radius_date_expiration',
    'radius_assessment',
    'radius_files',
    'radius_group',
    'radius_group_split',
    'radius_tag',
    'radius_tags',
    'radius_sprint',
    'radius_parent',
    'radius_children',
    'radius_visibility_off',
    'radius_close',
    'radius_more',
    'radius_note',
    'radius_person_add',
    'radius_person_outline',
    'radius_gift',
    'radius_add_task',
    'radius_add_parent',
    'radius_add_child',
    'radius_pin',
    'radius_exit',
    'radius_tariff_on',
    'radius_tariff_off',
    'radius_tariff_on_small',
    'radius_tariff_off_small',
    'radius_minus',
    'radius_learning_book',
    'radius_partner',
    'radius_print',
    'radius_emoji',
    'radius_boards',
    'radius_calendar_small',
    'radius_chat_task',
    'radius_chat_company',
    'radius_chat_phonebook',
    'radius_tagged',
    'radius_chat_matrix',
    'radius_chat_bell_on',
    'radius_chat_bell_off',
    'radius_boards_bold',
    'radius_insert_file',
    'radius_insert_image',
    'radius_progress_activity',
    'radius_calendar_start',
    'radius_upload',
    'radius_export',
    'radius_arrow_right',
    'radius_reply',
    'radius_matrix_tab_one',
    'radius_matrix_tab_quarter',
    'radius_matrix_tab_year',
    'radius_matrix_tab_half-year',
    'radius_share',
    'radius_share_2',
    'radius_angle_arrow',
    'radius_f',
    'radius_calendar',
    'radius_done_all',
    'radius_tasks_updated',
    'radius_tile',
    'radius_more_vert',
    'radius_public_group',
    'radius_exit-2',
    'radius_chat_avatar',
    'radius_exit-2',
    'radius_settings_menu',
    'radius_sort_date_asc',
    'radius_sort_date_desc',
    'radius_sort_priority_asc',
    'radius_sort_priority_desc',
    'radius_sort_status_asc',
    'radius_sort_status_desc',
    'radius_sort_groups',
    'radius_sort_tags',
    'radius_role_all',
    'radius_role_performer',
    'radius_role_observer',
    'radius_work_outline',
    'radius_password',
    'radius_wallet',
    'radius_rad',
    'radius_swap_vert',
    'radius_tasks-app',
    'radius_phonebook-app',
    'radius_calendar-app',
    'radius_news-app',
    'radius_company-app',
    'radius_knowledge-base-app',
    'radius_company-tab',
    'radius_news-tab',
    'radius_record',
    'radius_academy',
    'radius_crm',
    'CRM_icon',
    'radius_frame_resizer',
    'tasks-holst',
    'radius_task_sticker',
    'radius_ai-star',
    'radius_max',
    'radius_full',
    'radius_comment',
    'radius_chat-tabs-chat',
    'radius_chat-tabs-boards',
    'radius_chat-tabs-calendar',
    'radius_chat-tabs-employees',
    'radius_chat-tabs-company',
    'radius_chat-tabs-finances',
    'radius_chat-tabs-matrix',
    'radius_chat-tabs-radius',
    'radius',
    'radius_protocol',
    'radius_logo',
];

export const MEET_ICONS = [
    'hand',
    'share',
    'mic_on',
    'mic_off',
    'cam_on',
    'cam_off',
    'camera_on',
    'camera_off',
    'rec',
    'reaction',
    'sound',
    'group',
    'link',
    'phone',
    'settings',
    'image',
    'hide_image',
    'cam_check',
    'not_active',
    'pin',
    'pin_filled',
    'ai_protocol',
    'protocol_info',
    'protocol',
];
